export default {"src":"/_next/static/media/search-icon.461b652d.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};